export const defaultJourneyDomainState = {
    journeysByOrderId: {},
    journeysById: {},
    journeysByReference: {}
};
//# sourceMappingURL=state.js.map